import { serviceActionsGenerator } from '../serviceGenerator'

const actionTypes = [
  '!ABORT_EXPORT_PARTNERS',
  '!EXPORT_PARTNERS',
  '!FETCH_PARTNER_DETAILS',
  '!INIT_CUSTOMER_PARTNERS_PAGE_LOAD',
  '!INIT_PROVIDER_PARTNERS_PAGE_LOAD',
  '!INIT_REMOVE_PARTNER',
  '!SEARCH_PARTNERS',
  '!UPDATE_PARTNER_CALCULATION_BASE',
  '!UPDATE_PARTNER',
  'CREATE_PARTNER',
  'FETCH_PARTNERS',
  'MERGE_AND_REMOVE_PARTNER',
  'REMOVE_PARTNER',
  'UPDATE_ORDER',
  'UPDATE_PAGE',
  'UPDATE_ROWS_PER_PAGE',
] as const

export default serviceActionsGenerator('partners', actionTypes)
